var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail Send Envelope"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail-send-envelope--envelope-email-message-unopened-sealed-close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.25 4.375H3.75C3.08696 4.375 2.45107 4.63839 1.98223 5.10723C1.51339 5.57607 1.25 6.21196 1.25 6.875V28.125C1.25 28.788 1.51339 29.4239 1.98223 29.8928C2.45107 30.3616 3.08696 30.625 3.75 30.625H31.25C31.913 30.625 32.5489 30.3616 33.0178 29.8928C33.4866 29.4239 33.75 28.788 33.75 28.125V6.875C33.75 6.21196 33.4866 5.57607 33.0178 5.10723C32.5489 4.63839 31.913 4.375 31.25 4.375Z",
    stroke: "#797979",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.25 7.5L15.9 16.31C16.35 16.575 16.915 16.7175 17.5 16.7175C18.085 16.7175 18.65 16.575 19.1 16.31L33.75 7.5",
    stroke: "#797979",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a165a9f46776cab39e7a75e7986b8c80.svg";
export { ForwardRef as ReactComponent };